import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const ListEditor = ({ id, title, hint, items, onChange }) => {
  const [value, setValue] = useState("");
  const add = () => {
    const v = value.trim();
    if (!v || items.some((i) => i.toLowerCase() === v.toLowerCase())) return;
    onChange([...items, v]);
    setValue("");
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`list-editor-${id}`}>
      <h3 className="font-display text-base font-semibold text-[#0E1E38]">{title}</h3>
      {hint && <p className="mt-0.5 text-xs text-slate-500">{hint}</p>}
      <div className="mt-3 flex flex-wrap gap-1.5">
        {items.length === 0 && <span className="text-sm text-slate-400">Nothing added yet</span>}
        {items.map((item) => (
          <span key={item} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-slate-50 py-1 pl-2.5 pr-1 text-sm" data-testid={`list-item-${id}-${item}`}>
            {item}
            <button onClick={() => onChange(items.filter((i) => i !== item))} className="rounded p-0.5 text-slate-400 hover:bg-rose-50 hover:text-rose-600" data-testid={`list-remove-${id}-${item}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </span>
        ))}
      </div>
      <div className="mt-3 flex gap-2">
        <Input value={value} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Add new…" className="h-9" data-testid={`list-input-${id}`} />
        <Button size="sm" variant="outline" onClick={add} data-testid={`list-add-${id}`}><Plus className="h-4 w-4" /> Add</Button>
      </div>
    </div>
  );
};
